import './link_path_editor.less';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import map from 'lodash/map';
import noop from 'lodash/noop';

import Select from './select.jsx';
import InputContainer from './input_container.jsx';

class LinkPathEditor extends React.Component {

  constructor() {
    super();

    this.displayName = 'LinkPathEditor';

    this.textInput = null;

    this.state = {
      focused: false
    };

    this.focus = this.focus.bind(this);
    this.handlePathChange = this.handlePathChange.bind(this);
  }

  render() {
    const {
      path,
      error,
      domainId,
      domainUrl,
      domainsForAccount,
      onEnterKeyUp,
      onDomainChange
    } = this.props;

    return (
      <div className="link-path-editor">
        <InputContainer error={error}>
          <div className={classNames(
            'combined-input-box', {
              focused: this.state.focused,
              error: error
            })}
          >
            {
              (domainsForAccount && domainsForAccount.length) > 1 ?
                <Select
                  searchable
                  clearable={false}
                  className="domain-container select-domain-container"
                  value={domainId}
                  options={map(domainsForAccount, (domain)=> {
                    return {
                      label: domain.get('url'),
                      value: domain.get('id')
                    };
                  })}
                  onChange={({ label, value })=> {
                    onDomainChange({
                      domainId: value,
                      domainUrl: label
                    });
                  }}
                />
              :
                <div className="domain-container">
                  <span>{ domainUrl }/</span>
                </div>
            }

            <div className="path-container">
              <input 
                ref={(input) => { this.textInput = input; }}
                onFocus={()=> {this.setState({focused:true}); }} 
                onBlur={()=> {this.setState({focused:false}); }}
                placeholder="my-link-url" 
                type="text" 
                onKeyUp={(e)=> {
                  if (e.keyCode === 13) {
                    onEnterKeyUp(e);
                  }
                }}
                onChange={this.handlePathChange} 
                value={path} />
            </div>
          </div>
        </InputContainer>
      </div>
    );
  }

  focus() {
    this.textInput.focus();
  }

  handlePathChange(e) {
    const path = e.target.value.replace(/[^a-zA-Z0-9]+/g,'-').toLowerCase();
    this.props.onPathChange(path);
  }

}

LinkPathEditor.propTypes = {
  domainId: PropTypes.number.isRequired,
  domainUrl: PropTypes.string.isRequired,
  domainsForAccount: PropTypes.array,
  onEnterKeyUp: PropTypes.func,
  onPathChange: PropTypes.func.isRequired,
  onDomainChange: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  error: PropTypes.string
};

LinkPathEditor.defaultProps = {
  onEnterKeyUp: noop
};

export default LinkPathEditor;
